import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
const FALLBACK_LANGUAGE = 'pl';
/**
 * Fetches the static "Fashionapps guide" content for a page, mirroring
 * useHelpArticles' fetch-with-language-fallback approach.
 */
function usePageGuideContent(pageKey) {
    const { i18n } = useTranslation();
    const [content, setContent] = useState(null);
    useEffect(() => {
        if (!pageKey) {
            setContent(null);
            return undefined;
        }
        let cancelled = false;
        setContent(null);
        const language = i18n.language || FALLBACK_LANGUAGE;
        const fetchContent = (lng) => fetch(`/content/guides/${lng}/${pageKey}.json`).then((response) => response.ok ? response.json() : Promise.reject());
        fetchContent(language)
            .catch(() => language === FALLBACK_LANGUAGE ? Promise.reject() : fetchContent(FALLBACK_LANGUAGE))
            .then((data) => {
            if (!cancelled) {
                setContent(data);
            }
        })
            .catch(() => {
            if (!cancelled) {
                setContent(null);
            }
        });
        return () => {
            cancelled = true;
        };
    }, [pageKey, i18n.language]);
    return content;
}
export default usePageGuideContent;
